import * as React from "react";
import { Dialog, DialogContent } from "@mui/material";

function ProgressStatus({ open, text }) {
  return (
    <Dialog keepMounted open={open} sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }} maxWidth="xs">
      <DialogContent>
        <div>
          Working on it. Please wait ...
          {text ? text + " %" : ""}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ProgressStatus;
